const nav = document.querySelector(".nav");
const startNav = nav.querySelector(".start-nav");
const goBack = nav.querySelector(".go-back");
const navTrigger = document.querySelector("#nav-trigger")
const closeNav = nav.querySelector(".mobile-menu-close");
const hamburgerZero = document.querySelector('.hamburger');
const navbarZero = document.querySelector('#main-navbar');
let subMenu;

startNav.addEventListener("click", (e) => {
    if (!nav.classList.contains("active")) {
        return;
    }
    if (e.target.closest(".menu-item-has-children")) {
        const hasChildren = e.target.closest(".menu-item-has-children");
        showSubMenu(hasChildren)
    }
})

goBack.addEventListener("click", () => {
    hideSubMenu();
})

navTrigger.addEventListener("click", () => {
    toggleNav();
})

closeNav.addEventListener("click", () => {
    toggleNav();
})

function showSubMenu(hasChildren) {
    subMenu = hasChildren.querySelector(".sub-menu");
    subMenu.classList.add("active");
    const menuTitle = hasChildren.querySelector("a").textContent;
    nav.querySelector(".current-menu-title").innerHTML = menuTitle;
    nav.querySelector(".mobile-menu-head").classList.add("active");
}

function hideSubMenu() {
    subMenu.classList.remove("active");
    nav.querySelector(".current-menu-title").innerHTML = "";
    nav.querySelector(".mobile-menu-head").classList.remove("active");
}

document.querySelector(".nav-overlay").addEventListener("click", () => {
    toggleNav();
})

function toggleNav() {
    nav.classList.toggle("active");
    document.querySelector(".nav-overlay").classList.toggle("active");
    hamburgerZero.classList.toggle('active-zero');
    navbarZero.classList.toggle('overlay-active')
}

window.onresize = function () {
    if (this.innerWidth > 1080) {
        if (nav.classList.contains("active")) {
            toggleNav();
        }
    }
}

// Change nav on scroll
window.addEventListener('scroll', function () {
    let mainNavbar = document.querySelector('#main-navbar');
    let mainNav = document.querySelector('.main-nav');
    let greenCircle = document.querySelector('.main-nav-green-circle');
    let navBtn = document.querySelector('.nav-btn');
    // let windowPosition = window.scrollY > 0;

    if(window.pageYOffset > 48) {
        mainNavbar.classList.add('scrolling-active');
        mainNav.classList.add('scrolling-padding');
        greenCircle.classList.add('scrolling-green-circle');
        navBtn.classList.add('scrolling-nav-btn');

        mainNavbar.classList.add('active-2023');

    } else {
        mainNavbar.classList.remove('scrolling-active');
        mainNav.classList.remove('scrolling-padding');
        greenCircle.classList.remove('scrolling-green-circle');
        navBtn.classList.remove('scrolling-nav-btn');

        mainNavbar.classList.remove('active-2023');

    }

    // mainNavbar.classList.toggle('scrolling-active', windowPosition);
    // mainNav.classList.toggle('scrolling-padding', windowPosition);
    // greenCircle.classList.toggle('scrolling-green-circle', windowPosition);
    // navBtn.classList.toggle('scrolling-nav-btn', windowPosition);

});